import React, { Component } from 'react';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GeoSearchInput from '../../components/geo-search-input';
import SearchMapContainer from '../../components/search-map-container';
import * as selectors from '../../reducers';
import styles from './search-page.module.scss';
import {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
} from '../../actions/ui';
import { ChevronDoubleRight } from '../../components/icons';

class SearchPage extends Component {
  constructor() {
    super();
    this.selectCouncil = this.selectCouncil.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }
  selectCouncil(councilId) {
    const { setActiveRegion, setActivePage } = this.props;
    setActiveRegion(councilId);
    setActivePage('region');
  }

  selectEntity(entityId) {
    const { setActiveEntity, setActivePage } = this.props;

    setActiveEntity(entityId);
    setActivePage('entity');
  }

  handleListClick(council) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectCouncil(council.id);
    };
  }

  handleEntityListClick(entity) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectEntity(entity.id);
    };
  }

  renderCouncils() {
    const { regions } = this.props;
    return (
      <ul className={styles.councilList}>
        {regions
          .filter((c) => {
            // Don't make a page for the "Other- inside or outside QLD" category
            return !c.name.includes('Other');
          })
          .map((council, i) => (
            <li key={i} className={styles.councilListElement}>
              <button
                type="button"
                className={styles.councilListElementButton}
                onClick={this.handleListClick(council)}
              >
                {council.name}
              </button>
            </li>
          ))}
      </ul>
    );
  }
  render() {
    return (
      <div>
        <div className={styles.searchPageHeader}>
          <div className={styles.mainHeading}>
            Understanding your education services
          </div>
          <hr className={styles.mainHeadingLine} />
          <div className={styles.subHeading}>
            This Queensland Audit Office interactive map allows you to explore
            the financial performance of Queensland's education entities for
            2022 and compare to other regions. You can see information on
            revenue, expenses, assets, liabilities and other measures such as
            student and staff numbers. Data is included for the Department of
            Education; Department of Employment, Small Business and Training;
            TAFE Queensland; seven universities and eight grammar schools. The
            eight grammar schools are also part of the non-state sector. There
            are 536 schools within that sector in Queensland, but only the eight
            grammar schools that are included in our interactive tool are public
            sector entities.
            <br />
            <br />
            To accompany our report <em>Enabling digital learning</em>, this map
            also allows you to compare internet speeds per student by region,
            school information technology (IT) funding, if students had access
            to the internet, and what types of devices they had access to.
          </div>
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Search the map</h3>
          <div className={styles.searchWrapper}>
            <GeoSearchInput onCouncilSelect={this.selectCouncil} />
          </div>
          <div className={styles.mapRow}>
            <div className={styles.mapWrapper}>
              <SearchMapContainer onCouncilSelect={this.selectCouncil} />
            </div>
            <div className={styles.entityListWrapper}>
              {['Universities', 'Schools', 'Other Institutions'].map(
                (entityType, i) => {
                  return (
                    <div key={entityType + i}>
                      <h4 className={styles.smallerCouncilHeadline}>
                        {entityLabelMatcher(entityType, 'plural')}
                      </h4>
                      <ul className={styles.searchEntityList}>
                        {this.props.entities
                          .filter((e) => e.entityCategory.includes(entityType))
                          .map((e) => {
                            return (
                              <li
                                onClick={this.handleEntityListClick(e)}
                                key={e.name}
                                role="button"
                                className={styles.li}
                              >
                                <ChevronDoubleRight
                                  fill="blue"
                                  width="10px"
                                  height="10px"
                                  style={{
                                    marginRight: 10,
                                    height: 10,
                                    width: 10,
                                  }}
                                />
                                {e.name}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>
            Select education regions from list
          </h3>
          <div className={styles.listWrapper}>{this.renderCouncils()}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
};

const mapStateToProps = (state) => ({
  regions: selectors.getRegions(state),
  entities: selectors.getEntities(state),
});

SearchPage.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  entities: PropTypes.arrayOf(PropTypes.object),
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setActiveEntity: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/search-page/search-page.js